import { TextField, InputAdornment, IconButton, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useState } from 'react';

type Props = {
	setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
};

export const SearchBar = ({ setSearchTerm }: Props) => {
	const theme = useTheme();
	const [inputValue, setInputValue] = useState('');

	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setInputValue(value);
		setSearchTerm(value);
	};

	const handleClear = () => {
		setInputValue('');
		setSearchTerm('');
	};

	return (
		<TextField
			id="padel-search"
			placeholder="Search for players..."
			type="search"
			variant="outlined"
			value={inputValue}
			onChange={handleSearch}
			fullWidth
			size="small"
			sx={{
				flex: 1,
				mx: { xs: 0, sm: 2 },
				'& .MuiOutlinedInput-root': {
					borderRadius: 28,
					backgroundColor: theme.palette.background.default,
					transition: theme.transitions.create(['box-shadow']),
					'&:hover': {
						backgroundColor: '#fff',
					},
					'&.Mui-focused': {
						backgroundColor: '#fff',
						boxShadow: '0 0 0 4px rgba(76, 175, 80, 0.1)',
					},
				},
			}}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon color="action" />
					</InputAdornment>
				),
				endAdornment: inputValue && (
					<InputAdornment position="end">
						<IconButton aria-label="Clear search" onClick={handleClear} edge="end" size="small">
							<ClearIcon fontSize="small" />
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};
